'use es6';

import { useDispatch, useSelector } from 'react-redux';
import { canUploadAttachments } from '../attachments/selectors/canUploadAttachments';
import MeetingsLinkContainer from '../meetings-links/containers/MeetingsLinkContainer';
import { getSelectedThread } from '../selected-thread/selectors/getSelectedThread';
import UnifiedThreadViewWrapperWithDragUpload from '../thread-view/components/UnifiedThreadViewWrapperWithDragUpload';
import ConnectedUnifiedThreadView from '../thread-view/containers/ConnectedUnifiedThreadView';
import { isPersistedThread } from '../threads/operators/isPersistedThread';
import { getShouldDisableAttachments } from '../widget-ui/selectors/getShouldDisableAttachments';
import { selectAttachmentFile } from '../file-uploads/actions/selectAttachmentFile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadView = () => {
  const shouldDisableDragAndDropUpload = useSelector(state => !isPersistedThread(getSelectedThread(state)) || getShouldDisableAttachments(state) || !canUploadAttachments(state, {
    thread: getSelectedThread(state)
  }));
  const selectedThread = useSelector(state => getSelectedThread(state));
  const dispatch = useDispatch();
  const onDropFiles = files => {
    if (!files || !files.length) {
      return;
    }
    const file = files[0];
    dispatch(selectAttachmentFile({
      file,
      thread: selectedThread
    }));
  };
  return /*#__PURE__*/_jsxs(UnifiedThreadViewWrapperWithDragUpload, {
    onDropFiles: onDropFiles,
    disabled: shouldDisableDragAndDropUpload,
    children: [/*#__PURE__*/_jsx(MeetingsLinkContainer, {}), /*#__PURE__*/_jsx(ConnectedUnifiedThreadView, {})]
  });
};
ThreadView.displayName = 'ThreadView';
export default ThreadView;